import * as React from "react";
import { mergeStyles, getTheme } from "@fluentui/react";
import { SubTab } from "./types";

const theme = getTheme();

const railStyle = mergeStyles({
  width: 30,
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  paddingTop: 8,
  backgroundColor: theme.palette.neutralLighterAlt,
  borderRight: `1px solid ${theme.palette.neutralLight}`,
});

// Office-style sideways tab: text rotated to read top-to-bottom along the pane edge.
const tabStyle = mergeStyles({
  writingMode: "vertical-rl",
  cursor: "pointer",
  padding: "10px 6px",
  fontSize: 12,
  color: theme.palette.neutralSecondary,
  borderLeft: "2px solid transparent",
  userSelect: "none",
  whiteSpace: "nowrap",
  selectors: {
    ":hover": {
      color: theme.palette.themePrimary,
      backgroundColor: theme.palette.neutralLighter,
    },
  },
});

const tabSelectedStyle = mergeStyles({
  color: theme.palette.themePrimary,
  fontWeight: 600,
  borderLeft: `2px solid ${theme.palette.themePrimary}`,
  backgroundColor: theme.palette.white,
  selectors: {
    ":hover": {
      backgroundColor: theme.palette.white,
    },
  },
});

export interface SideNavProps {
  tabs: SubTab[];
  selectedKey: string;
  onSelect: (key: string) => void;
}

const SideNav: React.FunctionComponent<SideNavProps> = ({ tabs, selectedKey, onSelect }) => {
  return (
    <nav className={railStyle}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          role="tab"
          tabIndex={0}
          aria-selected={tab.key === selectedKey}
          className={`${tabStyle} ${tab.key === selectedKey ? tabSelectedStyle : ""}`}
          onClick={() => onSelect(tab.key)}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </nav>
  );
};

export default SideNav;
